import type { PartnerProductInsightsAPIPartner } from 'src/services/partner-product-insights-api/types/PartnerProductInsightsAPIPartner';
import type { PartnerInsights } from '../types';

export const adaptPartnerInsightsForStore = (
  partnerInsights: PartnerProductInsightsAPIPartner,
): PartnerInsights => {
  const { scores, type: _type, ...rest } = partnerInsights;

  return {
    ...rest,
    scores: {
      arrivedOnTime: {
        score: scores.arrivedOnTime.score,
        totalResponses: scores.arrivedOnTime.total_responses,
      },
      hasRecommendedNOTHS: {
        score: scores.hasRecommendedNOTHS.score,
        totalResponses: scores.hasRecommendedNOTHS.total_responses,
      },
      neededToContactSeller: {
        score: scores.neededToContactSeller.score,
        totalResponses: scores.neededToContactSeller.total_responses,
      },
      valueForMoney: {
        score: scores.valueForMoney.score,
        totalResponses: scores.valueForMoney.total_responses,
      },
      wasTheProductAsAdvertised: {
        score: scores.wasTheProductAsAdvertised.score,
        totalResponses: scores.wasTheProductAsAdvertised.total_responses,
      },
    },
  };
};
